export const StaffActionTypes = {
    API_RESPONSE_SUCCESS: '@@staff/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@staff/API_RESPONSE_ERROR',

    GET_EMPLOYEE: '@@staff/GET_EMPLOYEE',
    LIST_EMPLOYEES: '@@staff/LIST_EMPLOYEES',
    ADD_EMPLOYEE: '@@staff/ADD_EMPLOYEE',
    UPDATE_EMPLOYEE: '@@staff/UPDATE_EMPLOYEE',
    DELETE_EMPLOYEE: '@@staff/DELETE_EMPLOYEE',

    RESET: '@@staff/RESET',
};
